module.exports = __webpack_public_path__ + "img/htgl2.9872dc11.png";